export const assetSubClassCategories = [
  {
    name: 'chart:widget.indicators.chipsSelector_all',
    value: '',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_stocks',
    value: 'stocks',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_themes',
    value: 'themes',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_etfs',
    value: 'etfs',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_indexes',
    value: 'indexes',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_commodities',
    value: 'commodities',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_govBonds',
    value: 'govBonds',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_fx',
    value: 'fx',
    data: [],
  },
  {
    name: 'chart:widget.indicators.chipsSelector_economics',
    value: 'economics',
    data: [],
  },
];
